module.exports = __webpack_public_path__ + "img/video1.52d94594.svg";